module.exports = __webpack_public_path__ + "static/react-themes-emma-32f15bcecef7c8766cf4c273b8779789.jpg";